import { orange } from '@/theme/colors'
import React from 'react'
import styled, { keyframes } from 'styled-components'

interface SpinnerProps {
	size?: number
	color?: string
	trackColor?: string
}

const spin = keyframes`
	0% { transform: rotate(0deg); }
	100% { transform: rotate(360deg); }
`

const Ring = styled.div<{ $size: number; $color: string; $trackColor: string }>`
	width: ${props => props.$size}px;
	height: ${props => props.$size}px;
	border: ${props => Math.max(3, Math.round(props.$size / 12))}px solid ${props => props.$trackColor};
	border-top-color: ${props => props.$color};
	border-radius: 50%;
	animation: ${spin} 0.8s linear infinite;
	flex-shrink: 0;
`

const Spinner: React.FC<SpinnerProps> = ({ size = 100, color = orange, trackColor = '#e9ecef' }) => (
	<Ring $size={size} $color={color} $trackColor={trackColor} />
)

export default Spinner
